import { render, staticRenderFns } from "./ContainerChildrem.vue?vue&type=template&id=47e070f5&scoped=true"
import script from "./ContainerChildrem.vue?vue&type=script&lang=js"
export * from "./ContainerChildrem.vue?vue&type=script&lang=js"
import style0 from "./ContainerChildrem.vue?vue&type=style&index=0&id=47e070f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e070f5",
  null
  
)

export default component.exports